(function () {
  'use strict';
  var bar;
  var activeRoot;
  var framePending = false;

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function copyFor(root) {
    var element = root.querySelector('[data-bettup-purchase-copy]');
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function variantFor(root) {
    var element = root.querySelector('[data-selected-variant]');
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function formFor(root) {
    return root.querySelector('form[id^="ProductForm-"]');
  }

  function heightFor(form) {
    return form && form.querySelector('[name="properties[Höhe]"]');
  }

  function showHeightWarning(form) {
    var height = heightFor(form);
    var warning = form.querySelector('[data-bu-height-warning]');
    if (warning) warning.hidden = false;
    if (height) {
      height.setAttribute('aria-invalid', 'true');
      height.scrollIntoView({ behavior: 'smooth', block: 'center' });
      height.focus({ preventScroll: true });
    }
  }

  function ensureBar(root, copy) {
    if (bar) return;
    activeRoot = root;
    bar = document.createElement('div');
    bar.className = 'bettup-purchase-bar';
    bar.hidden = true;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', copy.barLabel);
    var content = document.createElement('div');
    content.className = 'bettup-purchase-bar__copy';
    var price = document.createElement('strong');
    price.setAttribute('data-bettup-bar-price', '');
    var description = document.createElement('span');
    description.setAttribute('data-bettup-bar-description', '');
    content.append(price, description);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bettup-purchase-bar__button';
    bar.append(content, button);
    document.body.appendChild(bar);
    button.addEventListener('click', function () {
      var form = activeRoot && formFor(activeRoot);
      var source = form && form.querySelector('.add-to-cart');
      if (!source || source.disabled) return;
      var height = heightFor(form);
      if (!height || !height.value) {
        showHeightWarning(form);
        return;
      }
      source.click();
    });
    window.addEventListener('scroll', scheduleBar, { passive: true });
    window.addEventListener('resize', scheduleBar, { passive: true });
  }

  function scheduleBar() {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(function () { framePending = false; updateBar(); });
  }

  function updateBar() {
    if (!bar || !activeRoot || !activeRoot.isConnected) return;
    var source = formFor(activeRoot)?.querySelector('.add-to-cart');
    var show = Boolean(source && matchMedia('(max-width: 749px)').matches && source.getBoundingClientRect().bottom < 0);
    bar.hidden = !show;
    document.body.classList.toggle('bettup-purchase-bar-visible', show);
    if (show) {
      var preview = document.getElementById('PBarNextFrame');
      var previewHeight = preview ? preview.getBoundingClientRect().height : 0;
      if (previewHeight > 250) previewHeight = 0;
      bar.style.bottom = previewHeight + 'px';
      document.body.style.setProperty('--bettup-purchase-offset', (bar.getBoundingClientRect().height + previewHeight + 12) + 'px');
    }
  }

  function sync(root) {
    var summary = root.querySelector('[data-bettup-selection]');
    var form = formFor(root);
    var copy = copyFor(root);
    if (!summary || !form || !copy) return;
    var variant = variantFor(root);
    var height = heightFor(form);
    var pending = root.dataset.bettupVariantPending === 'true';
    var failed = root.dataset.bettupVariantError === 'true';
    var variantInput = form.querySelector('.product-variant-id');
    var available = Boolean(variant && variant.available && variantInput && !variantInput.disabled);
    var validHeight = Boolean(height && height.value);
    var options = variant && (variant.options || [variant.option1, variant.option2, variant.option3]);
    var description = (options || []).filter(Boolean).map(function (value) {
      var match = String(value).match(/^Härtegrad\s*(\d)/i);
      return match ? 'H' + match[1] : String(value);
    }).join(' · ');
    var message = pending ? copy.updating : failed ? copy.error : '';
    var price = root.querySelector('[id^="productPrice-"]')?.textContent.trim() || '';
    setText(summary.querySelector('[data-bettup-summary-options]'), description);
    setText(summary.querySelector('[data-bettup-summary-height]'), validHeight ? height.value : copy.missingHeight);
    setText(summary.querySelector('[data-bettup-summary-price]'), price);
    summary.querySelector('[data-bettup-summary-price]').hidden = pending || failed;
    var status = summary.querySelector('[data-bettup-selection-status]');
    setText(status, message);
    status.hidden = !message;
    summary.querySelector('[data-bettup-selection-reload]').hidden = !failed;
    summary.classList.toggle('is-complete', validHeight && available && !pending && !failed);
    var source = form.querySelector('.add-to-cart');
    if (source) source.disabled = pending || failed || !available;
    var express = form.querySelector('[data-bettup-express]');
    if (express) express.hidden = !validHeight || pending || failed || !available;
    if (validHeight) {
      height.removeAttribute('aria-invalid');
      var warning = form.querySelector('[data-bu-height-warning]');
      if (warning) warning.hidden = true;
    }
    ensureBar(root, copy);
    if (root === activeRoot) {
      setText(bar.querySelector('[data-bettup-bar-price]'), pending || failed ? copy.barCheck : price);
      setText(bar.querySelector('[data-bettup-bar-description]'), description + ' · ' + (validHeight ? height.value : copy.missingHeight));
      var proxy = bar.querySelector('button');
      setText(proxy, validHeight ? copy.barAdd : copy.barChoose);
      proxy.disabled = pending || failed || !available;
      updateBar();
    }
  }

  function guard(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var form = target.closest('form[id^="ProductForm-"]');
    if (!form || !form.querySelector('[data-bettup-selection]')) return;
    if (event.type === 'click' && !target.closest('.add-to-cart, button[type="submit"], [data-bettup-express]')) return;
    var root = form.closest('.content.product');
    var height = heightFor(form);
    if (root.dataset.bettupVariantPending || root.dataset.bettupVariantError || !height || !height.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!height || !height.value) showHeightWarning(form);
    }
  }

  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-bu-height-select]')) return;
    var root = event.target.closest('.content.product');
    if (root) sync(root);
  });
  ['bettup:variant-loading', 'bettup:variant-changed', 'bettup:variant-error'].forEach(function (name) {
    document.addEventListener(name, function (event) { sync(event.target); });
  });
  function scan() { document.querySelectorAll('.bettup-core-product').forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
